import { Body, Box, Container, Heading } from '@hover/blueprint';
import { ButtonProps } from '@hover/blueprint/brand';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import ArrowButton from '../../ui/ArrowButton';

const CareerHero: React.FC = () => {
  const onOpenRolesClick: ButtonProps['onClick'] = event => {
    if (!(event.currentTarget instanceof HTMLAnchorElement)) return;

    const { hash } = new URL(event.currentTarget.href);
    const element = document.querySelector(hash);

    if (!element) return;

    event.preventDefault();

    element.scrollIntoView({
      behavior: 'chrome' in window ? undefined : 'smooth',
    });

    window.history.pushState(null, document.title, hash);
  };

  return (
    <Box
      w="100%"
      bg="brandNavy.500"
      height={{ base: 'auto', desktop: '621px' }}
      overflow="hidden"
      alignItems="center"
      pt={{ base: 700, desktop: 0 }}
      pb={{ base: 1000, desktop: 0 }}
    >
      <Container maxW="1232px" px={200}>
        <Box
          alignItems="center"
          justifyContent="space-between"
          flexDir={{ base: 'column', desktop: 'row' }}
        >
          <Container
            maxW={{ base: '3xl', desktop: '700px' }}
            display="flex"
            flexDirection="column"
            alignItems={{ base: 'center', desktop: 'start' }}
          >
            <Heading
              size={{ base: 600, tablet: 700, desktop: 800 }}
              style={{ marginBottom: 0, color: 'white', fontWeight: 700 }}
              textAlign={{ base: 'center', desktop: 'left' }}
            >
              We’re always looking to improve our home.
            </Heading>
            <Body
              maxW={{ base: '100%', desktop: 'lg' }}
              mt={500}
              mb={700}
              size={500}
              color="neutral.0"
              textAlign={{ base: 'center', desktop: 'left' }}
            >
              At HOVER, we’re on the lookout for creative thinkers and doers who
              see opportunity in every challenge, and possibilities in every
              problem. Ready to join the team?
            </Body>
            <ArrowButton
              as="a"
              display="inline-flex"
              href={`${process.env.GATSBY_V2_PREFIX}/careers#open-roles`}
              onClick={onOpenRolesClick}
              colorScheme="brandNavy"
              variant="inverted"
              width="auto"
            >
              View open roles
            </ArrowButton>
          </Container>
          <Container
            mt={{ base: '72px', desktop: 0 }}
            maxW="450px"
            px={{ base: 500, desktop: 0 }}
          >
            <StaticImage
              quality={100}
              placeholder="blurred"
              src="../../../assets/images/careers_hero.png"
              alt="careers hero vector"
              width={450}
            />
          </Container>
        </Box>
      </Container>
    </Box>
  );
};

export default CareerHero;
